export class DateFilter {

  constructor(
    public text?: string,
    public dayDelta?: number
  ) { }
}
